module.exports = __webpack_public_path__ + "static/media/planilhas-maxi-frete.e7151ace.png";